import React from 'react';
import { useField } from 'formik';
import {
    Radio,
    RadioGroup,
    FormHelperText,
    FormControl,
    FormControlLabel,
    FormLabel,
} from '@material-ui/core';

const RadioButtonGroup = ({ legend, values, ...props }) => {
    const [field, meta] = useField(props);
    const showError = meta.touched && meta.error;

    return (
        <>
            <FormControl component="fieldset" style={{ marginTop: '14px', width: '100%' }}>
                <FormLabel component="legend">{legend}</FormLabel>
                <RadioGroup aria-label="" name={props.name} {...props} {...field} row>
                    {values.map((v, index) => {
                        return <FormControlLabel value={`${v.value}`} label={v.label} control={<Radio />} key={index}/>;
                    })}
                </RadioGroup>
                <FormHelperText error={!!showError}>{showError}</FormHelperText>
            </FormControl>
        </>
    );
};

export default RadioButtonGroup;
